<section
  *transloco="let t"
  class="reset-password-change-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <form
    *ngIf="!(submitted && success)"
    class="form"
    name="reset-password-change"
    (ngSubmit)="resetPassword()">
    <h2 class="title">{{ t('Reset password') }}</h2>
    <h3 class="subtitle">{{ t('subtitle_reset_password_step_2') }}</h3>
    <div class="form-field" [class.rtl]="isRtlLayout$ | async">
      <span class="label">{{ t('hint_password') }}</span>
      <input
        data-clarity-unmask
        #password
        matInput
        class="field password"
        [type]="hidePassword ? 'password' : 'text'"
        [formControl]="passwordFormControl"
        autocomplete="password"
        required />
      <button
        type="button"
        mat-icon-button
        matSuffix
        (click)="togglePassword($event)"
        [attr.aria-label]="
          t(hidePassword ? 'action_hide_password' : 'action_show_password')
        "
        [attr.aria-pressed]="hidePassword">
        <ng-container *ngIf="!hidePassword">
          <popsy-icon-view-off
            class="icon gray-02"
            aria-hidden="true"></popsy-icon-view-off>
        </ng-container>
        <ng-container *ngIf="hidePassword">
          <popsy-icon-view-1 class="icon gray-02" aria-hidden="true"></popsy-icon-view-1>
        </ng-container>
      </button>

      <span class="error" *ngIf="passwordFormControl.hasError('required')">
        {{ t('error_password_required') }}
      </span>
      <span class="error" *ngIf="passwordFormControl.hasError('minlength')">
        {{ t('error_password_too_short', { var1: 6 }) }}
      </span>
      <span class="error" *ngIf="passwordFormControl.hasError('UNAUTHORIZED')">
        {{ t('error_reset_password_expired') }}
      </span>
      <span class="error" *ngIf="passwordFormControl.hasError('UNKNOWN')">
        {{ t('error_login_unknown') }}
      </span>
    </div>

    <div aria-hidden="true" class="dynamic-space"></div>
    <button
      type="submit"
      class="button popsy-button-primary"
      [class.error]="submitted && failed"
      [class.success]="submitted && success"
      (click)="resetPassword()"
      [disabled]="passwordFormControl?.status !== 'VALID'">
      <app-loading class="spinner" *ngIf="loading"></app-loading>
      <span *ngIf="!loading" class="button-message">
        {{ t('button_reset_password') }}
      </span>
    </button>
  </form>
  <div *ngIf="submitted && success" class="check-your-email">
    <popsy-icon-new-password
      class="illustration"
      aria-hidden="true"></popsy-icon-new-password>
    <div class="message">
      <h2 class="title">{{ t('message_title_reset_password_step_2') }}</h2>
      <h3 class="description">{{ t('message_reset_password_step_2') }}</h3>
      <div aria-hidden="true" class="dynamic-space"></div>
      <button type="submit" class="button popsy-button-primary" (click)="loggedIn()">
        <span class="button-message">{{ t('title_login') }}</span>
      </button>
    </div>
  </div>
</section>
